import { createFileRoute } from "@tanstack/react-router";
import { TidsplanlaegningPage, tidsplanlaegningHead } from "@/pages/TidsplanlaegningPage";

export const Route = createFileRoute("/tidsplanlaegning")({
  head: () => tidsplanlaegningHead("da"),
  component: () => <TidsplanlaegningPage locale="da" />,
});
